import axios from 'axios';
import React, { useState } from 'react';
import { Button, Form } from 'choerodon-ui/pro';

// import './c7n-ued-polyfill.important.less';
import intl from 'utils/intl';
import styles from './index.less';


export const withTokenAxios = axios;


const QueryBarMore = ({ queryFields, buttons, queryFieldsLimit = 3, dataSet, queryDataSet }) => {
    const [hidden, setHidden] = useState(true);
    const handleToggle = () => {
      setHidden(!hidden);
    };
    const query = async () => {
      if (await dataSet.validate(false, false)) {
        await dataSet.query();
      }
    };
    return (
      <div>
        {queryDataSet ? (
          <div className={styles['queryBar-toolbar']}>
            <Form
              className={styles['queryBar-toolbar-from']}
            //   style={{ flex: 'auto' }}
              columns={queryFieldsLimit}
              dataSet={queryDataSet}
              labelWidth={110}
              labelAlign='right'
              onKeyDown={(e) => {
                if (e.keyCode === 13) return query();
              }}
            >
              {hidden ? queryFields.slice(0, queryFieldsLimit) : queryFields}
            </Form>
            <div className={styles['queryBar-toolbar-more']}>
              {queryFields.length > queryFieldsLimit && (
                <Button onClick={handleToggle}>
                  {hidden
                    ? intl.get('hzero.common.button.viewMore').d('更多查询')
                    : intl.get('hzero.common.button.collected').d('收起查询')}
                </Button>
              )}
              <Button
                onClick={() => {
                  queryDataSet.current.reset();
                  dataSet.fireEvent('queryBarReset', {
                    dataSet,
                    queryFields,
                  });
                }}
              >
                {intl.get('hzero.common.button.reset').d('重置')}
              </Button>
              <Button dataSet={null} color="primary" onClick={query}>
                {intl.get('hzero.common.button.search').d('查询')}
              </Button>
            </div>
          </div>
        ) : null}
        {buttons && buttons.length ? <div className={styles['queryBar-toolbar-from-buttons']}>{buttons}</div> : null}
      </div>
    );
  };
  export default QueryBarMore;